module.exports = __webpack_public_path__ + "static/media/UP_L2.ceeef7ee.svg";